// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Footer styles */
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  left: 0;
  background-color: #f8f9fa;
  padding: 8px 0;
  text-align: center;
  border-top: 1px solid #e9ecef;
}

.footer.dark {
  background-color: #2c3e50;
  border-top: 1px solid #34495e;
  color: #ecf0f1;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.footer-links a {
  margin-left: 15px;
  text-decoration: none;
  color: inherit;
}

.footer-links a:hover {
  text-decoration: underline;
}

/* Dark mode link colors */
.footer.dark a {
  color: #ecf0f1;
}

.footer:not(.dark) a {
  color: #495057;
}

/* Responsive design */
@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .social-links {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Footer.css"],"names":[],"mappings":";AACA,kBAAkB;AAClB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,OAAO;EACP,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["\n/* Footer styles */\n.footer {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  left: 0;\n  background-color: #f8f9fa;\n  padding: 8px 0;\n  text-align: center;\n  border-top: 1px solid #e9ecef;\n}\n\n.footer.dark {\n  background-color: #2c3e50;\n  border-top: 1px solid #34495e;\n  color: #ecf0f1;\n}\n\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n}\n\n.footer-links a {\n  margin-left: 15px;\n  text-decoration: none;\n  color: inherit;\n}\n\n.footer-links a:hover {\n  text-decoration: underline;\n}\n\n/* Dark mode link colors */\n.footer.dark a {\n  color: #ecf0f1;\n}\n\n.footer:not(.dark) a {\n  color: #495057;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .footer-content {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n  \n  .social-links {\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
